import { Box, Button, ButtonGroup, useTheme } from "@material-ui/core";
import React from "react";

interface IProps {
  handleNext: () => void;
  handlePrev: () => void;
  currentPage: number;
  pageSize: number;
  total: number;
  currentSize: number;
}

const PaginationComponent: React.FC<IProps> = ({
  handleNext,
  handlePrev,
  currentPage,
  pageSize,
  total,
  currentSize,
}) => {
  const theme = useTheme();
  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end" my={2}>
      <ButtonGroup
        color="primary"
        variant="contained"
        disableElevation
      >
        <Button
          style={{
            backgroundColor: theme.palette.common.white,
            textTransform: "none",
            color: theme.palette.common.black,
            fontWeight: theme.typography.fontWeightRegular,
          }}
        >
          Page size : {pageSize}
        </Button>
        <Button
          style={{
            backgroundColor: theme.palette.primary.main,
            textTransform: "none",
          }}
          disabled={currentPage === 1}
          onClick={handlePrev}
        >
          Prev
        </Button>
        <Button
          style={{
            backgroundColor: theme.palette.primary.main,
            textTransform: "none",
          }}
        >
          {currentPage}
        </Button>
        <Button
          style={{
            backgroundColor: theme.palette.primary.main,
            textTransform: "none",
          }}
          disabled={
            total < currentPage * pageSize ||
            currentSize < pageSize ||
            pageSize * currentPage === total
          }
          onClick={handleNext}
        >
          Next
        </Button>
      </ButtonGroup>
    </Box>
  );
};

export default PaginationComponent;
